import { useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { ChevronLeft, Play, Send } from 'lucide-react'
import YoutubeIcon from '@/components/icons/YoutubeIcon'
import RichText from '@/components/RichText'
import { DERNIERES_PREDICATIONS } from '@/data/predications'

export default function PredicationDetailPage() {
  const { id } = useParams<{ id: string }>()
  const [playing, setPlaying] = useState(false)

  const predication = DERNIERES_PREDICATIONS.find((p) => p.id === id)
  

  if (!predication) {
    return (
      <div className="max-w-lg mx-auto px-4 py-20 text-center">
        <p className="text-cmp-navy font-bold text-lg">Prédication introuvable</p>
        <p className="text-gray-500 text-sm mt-2">Elle a peut-être été déplacée ou retirée.</p>
        <Link
          to="/predications"
          className="mt-6 inline-flex items-center gap-1.5 text-cmp-blue font-semibold text-sm hover:gap-2.5 transition-all"
        >
          <ChevronLeft size={14} />
          Retour aux prédications
        </Link>
      </div>
    )
  }

  
  const { titre, resume, predicateur, date, serie, videoId } = predication
  const youtubeUrl = `https://www.youtube.com/watch?v=${videoId}`
  const handleShare = () => {
    const url = `${window.location.origin}/predications/${predication.id}`
    const texte = `${titre} — écoutez cette prédication du CMP Lubumbashi : ${url}`
    window.open(`https://wa.me/?text=${encodeURIComponent(texte)}`, '_blank', 'noopener,noreferrer')
  }

  return (
    <article className="px-4 py-10 md:py-14">
      <div className="max-w-2xl mx-auto">
        <Link
          to="/predications"
          className="inline-flex items-center gap-1.5 text-cmp-blue font-semibold text-sm hover:gap-2.5 transition-all"
        >
          <ChevronLeft size={14} />
          Retour aux prédications
        </Link>

        <div className="relative aspect-video bg-cmp-navy rounded-2xl overflow-hidden mt-6 shadow-[0_8px_28px_rgba(15,31,92,0.12)] ring-1 ring-cmp-navy/6">
          {playing ? (
            // Lecteur de PRÉVISUALISATION (voir data/media.ts) — TODO: brancher la vraie vidéo de la prédication.
            <iframe
              className="w-full h-full"
              src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1`}
              title={titre}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          ) : (
            <button
              type="button"
              onClick={() => setPlaying(true)}
              aria-label={`Lire : ${titre}`}
              className="group relative w-full h-full flex items-center justify-center"
            >
              {/* Vignette Unsplash de PRÉVISUALISATION — TODO: remplacer par la vraie miniature */}
              <img src={`https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`} alt="" loading="eager" className="absolute inset-0 w-full h-full object-cover" />
              <div className="absolute inset-0 bg-cmp-navy/40 group-hover:bg-cmp-navy/30 transition-colors" />
              <span className="relative w-16 h-16 rounded-full bg-white/15 ring-1 ring-white/30 backdrop-blur-sm group-hover:bg-white/25 transition-colors flex items-center justify-center">
                <Play size={24} fill="white" color="white" className="ml-0.5" />
              </span>
            </button>
          )}
        </div>

        <p className="text-cmp-gold text-xs font-bold uppercase tracking-widest mt-6">{serie}</p>
        <h1 className="text-2xl md:text-3xl font-bold text-cmp-navy mt-1">{titre}</h1>
        <p className="text-gray-400 text-sm mt-1">{predicateur} · {date}</p>

        <div className="mt-6 flex gap-3">
          <button
            type="button"
            onClick={() => setPlaying(true)}
            className="flex-1 sm:flex-none sm:px-8 bg-cmp-navy text-white rounded-full py-3 text-sm font-semibold flex items-center justify-center gap-2 shadow-md shadow-cmp-navy/15 hover:bg-cmp-navy-light transition-colors active:scale-95"
          >
            <Play size={14} fill="white" />
            Écouter
          </button>
          <a
            href={youtubeUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 sm:flex-none sm:px-8 border border-cmp-navy/20 text-cmp-navy rounded-full py-3 text-sm font-semibold flex items-center justify-center gap-2 hover:bg-cmp-sky-light transition-colors active:scale-95"
          >
            <YoutubeIcon size={14} />
            YouTube
          </a>
          <button
            type="button"
            onClick={handleShare}
            aria-label="Partager sur WhatsApp"
            className="w-11 shrink-0 border border-cmp-navy/20 text-cmp-navy rounded-full flex items-center justify-center hover:bg-cmp-sky-light transition-colors active:scale-95"
          >
            <Send size={15} />
          </button>
        </div>

        <div className="mt-10 pt-8 border-t border-gray-100">
          <p className="text-cmp-gold text-xs font-bold uppercase tracking-widest mb-3">Résumé</p>
          <RichText>{resume}</RichText>
        </div>
      </div>
    </article>
  )
}
